import dayjs from 'dayjs';

export type DraftSlice = {
    isLoading: boolean;
    draftId?: unknown;
    draftReason?: string;
    memberId?: number;
    itemId?: number;
    restart?: boolean;
    publishedPromoted?: unknown;
    publishedHighlighted?: unknown;
    createdDate?: unknown;
    lastModifiedDate?: string;
    publishedDate?: unknown;
    publishedAsItemType?: unknown;
    reference?: string;
    referenceIsReadonly?: unknown;
    additionalDescriptions?: { message: string }[];
    metadata?: unknown;
    templateId?: unknown;
    templateName?: unknown;
    version?: unknown;
    isNewDraft?: unknown;
    descriptionLanguageCodeIso2?: string;
    currency?: string;
    resellPartner?: unknown;
};

const initialState = {
    isLoading: false
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default (state: DraftSlice = initialState, action: any) => {
    let newDraft = null;
    switch (action.type) {
        case 'SET_DRAFT_PROPERTIES': {
            const referenceIsReadonly =
                action.draft.reference &&
                action.draft.reference.indexOf('Sello artnr') >= 0;
            newDraft = {
                ...initialState,
                ...action.payload,
                draftId: action.draft.draftId,
                draftReason: action.draft.draftReason,
                memberId: action.draft.memberId,
                itemId: action.draft.itemId,
                restart: action.draft.restart,
                publishedPromoted: action.draft.publishedPromoted,
                publishedHighlighted: action.draft.publishedHighlighted,
                createdDate: action.draft.createdDate,
                lastModifiedDate: action.draft.lastModifiedDate,
                publishedDate: action.draft.publishedDate,
                publishedAsItemType: action.draft.publishedAsItemType,
                reference: action.draft.reference,
                referenceIsReadonly: referenceIsReadonly,
                additionalDescriptions: action.draft.additionalDescriptions,
                metadata: action.draft.metadata,
                templateId: action.draft.templateId,
                templateName: action.draft.templateName,
                version: action.draft.version,
                isNewDraft: !action.draft.draftId
            };
            break;
        }
        case 'SET_DRAFT_ID':
            newDraft = { ...state, draftId: action.payload };
            break;
        case 'SET_RESTART':
            newDraft = { ...state, restart: action.payload };
            break;
        case 'DISABLE_RESTART':
            newDraft = { ...state, restart: false };
            break;
        case 'SET_REFERENCE':
            newDraft = { ...state, reference: action.payload };
            break;
        case 'ADD_ADDITIONAL_DESCRIPTION': {
            const newAdditionalDescriptions = state.additionalDescriptions
                ? [...state.additionalDescriptions]
                : [];
            newAdditionalDescriptions.push({ message: action.payload });
            newDraft = {
                ...state,
                additionalDescriptions: newAdditionalDescriptions
            };
            break;
        }
        case 'SET_DRAFT_REASON':
            newDraft = { ...state, draftReason: action.payload };
            break;
        case 'SET_DRAFT_VERSION':
            newDraft = { ...state, version: action.payload };
            break;
        case 'RESET_DRAFT':
            newDraft = { ...initialState };
            break;
        case 'SET_DRAFT_IS_LOADING':
            newDraft = { ...state, isLoading: action.payload };
            break;
        case 'SET_DESCRIPTION_LANGUAGECODE':
            newDraft = {
                ...state,
                descriptionLanguageCodeIso2:
                    action.payload.descriptionLanguageCodeIso2
            };
            break;
        case 'SET_CURRENCY':
            newDraft = {
                ...state,
                currency: action.payload.currency
            };
            break;
        case 'SET_RESELL_PARTNER':
            newDraft = {
                ...state,
                resellPartner: action.payload.resellPartner
            };
            break;
        default:
            return state;
    }
    if (JSON.stringify(state) != JSON.stringify(newDraft)) {
        newDraft.lastModifiedDate = dayjs().toISOString();
    }
    return newDraft;
};
